import {
  // GET_TAGS,
  SET_LOADING,
  GET_SEARCH_RESULTS_ALL,
  SET_CONSCIOUS_FILTER,
  SET_CUISINE_FILTER,
  SET_MEAL_FILTER,
  SET_PRICE_FILTER,
  SET_VIBE_FILTER,
  SET_NEIGHBORHOOD_FILTER,
  SET_LIFESTYLE_FILTER,
  SET_DINING_FILTER,
  SET_RESTAURANT_SEARCH_FILTER,
  GET_SEARCH_RESULTS_MAP,
  GET_ARTICLE_MAP,
  CLEAR_ALL_FILTERS,
  CLEAR_RESTAURANT_LIST,
} from "./types";
import mapboxgl from "mapbox-gl";
import axios from "axios";

//get all restaurants in a city
export const getAllSearchResults = city => async dispatch => {
  try {
    setLoading();
    let res = await axios.get(
      `https://tablesageapi.com/api/restaurants?city=${city}&sort=-name&active=true`
    );

    //sort restaurant list alphabetically
    if (res.data.data.length) {
      res.data.data = res.data.data.sort(function (a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (b.name.toLowerCase() > a.name.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    }

    dispatch({
      type: GET_SEARCH_RESULTS_ALL,
      payload: res.data.data,
    });
  } catch (err) {
    // LogRocket.log(err.message);
  }
};

//get user search results map and restaurant card list
export const getSearchResultsMap = (
  city,
  consciousFilter,
  lifestyleFilter,
  cuisineFilter,
  diningFilter,
  mealFilter,
  restaurantSearchFilter,
  history,
  priceFilter,
  vibeFilter,
  neighborhoodFilter
) => async dispatch => {
  try {
    setLoading();
    let res;
    let searchQuery = history.search;
    const params = new URLSearchParams(searchQuery);
    const searchedRestaurant = params.get("restaurant");
    const preFilteredLifestyle = params.get("lifestyle");
    const preFilteredDining = params.get("dining");

    //check if user searched for specific restaurant
    if (restaurantSearchFilter) {
      res = await axios.get(
        `https://tablesageapi.com/api/restaurants?_id=${restaurantSearchFilter}&active=true`
      );
      //check if url contains specific restaurant
    } else if (searchedRestaurant) {
      dispatch(setFilters({ restaurantSearchFilter: searchedRestaurant }));
      res = await axios.get(
        `https://tablesageapi.com/api/restaurants?_id=${searchedRestaurant}&active=true`
      );
      //check if url contains a lifestyle filter
    } else if (preFilteredLifestyle) {
      const lifestyleArray = preFilteredLifestyle.split(" ");
      dispatch(setFilters({ lifestyleFilter: lifestyleArray }));
      res = await axios.get(
        `https://tablesageapi.com/api/restaurants?lifestyle=${lifestyleArray.join(
          ","
        )}&active=true`
      );
    } else if (preFilteredDining) {
      const diningArray = preFilteredDining.split(" ");
      dispatch(setFilters({ diningFilter: diningArray }));
      res = await axios.get(
        `https://tablesageapi.com/api/restaurants?diningOptions=${diningArray.join(
          ","
        )}&active=true`
      );
    }
    //search database for restaurants matching user's filters
    else {
      let queryString = `https://tablesageapi.com/api/restaurants?city=${city}&sort=-name&active=true`;

      //add lifestyle filter to query string
      if (lifestyleFilter.length) {
        let lifestyleList;
        lifestyleList = lifestyleFilter.join();
        queryString += `&lifestyle=${lifestyleList}`;
      }

      //add price filter to query string
      if (priceFilter.length) {
        let priceList;
        priceList = priceFilter.join();
        queryString += `&price=${priceList}`;
      }

      //add vibe filter to query string
      if (vibeFilter.length) {
        let vibeList;
        vibeList = vibeFilter.join();
        queryString += `&vibe=${vibeList}`;
      }

      //add neighborhood filter to query string
      if (neighborhoodFilter.length) {
        let neighborhoodList;
        neighborhoodList = neighborhoodFilter.join();
        queryString += `&neighborhood=${neighborhoodList}`;
      }

      //add cuisine filter to query string
      if (cuisineFilter.length) {
        let cuisineList;
        cuisineList = cuisineFilter.join();
        queryString += `&cuisine=${cuisineList}`;
      }

      //add meal filter to query string
      if (mealFilter.length) {
        let mealList;
        mealList = mealFilter.join();
        queryString += `&meals=${mealList}`;
      }

      //add dining filter to query string
      if (diningFilter.length) {
        let diningList;
        diningList = diningFilter.join();
        queryString += `&diningOptions=${diningList}`;
      }

      //add conscious filters to query string
      if (consciousFilter.length) {
        if (consciousFilter.includes("Experience")) {
          queryString += `&experienceRating=true`;
        }
        if (consciousFilter.includes("Cuisine")) {
          queryString += `&cuisineRating=true`;
        }
        if (consciousFilter.includes("Story")) {
          queryString += `&storyRating=true`;
        }
        if (consciousFilter.includes("Sustainability")) {
          queryString += `&sustainabilityRating=true`;
        }
        if (consciousFilter.includes("Diversity")) {
          queryString += `&diversityRating=true`;
        }
      }

      res = await axios.get(queryString);
    }

    //sort restaurant list alphabetically
    if (res.data.data.length) {
      res.data.data = res.data.data.sort(function (a, b) {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (b.name.toLowerCase() > a.name.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    }

    //pull this month's featured restaurants to the top
    function pullFeaturedToTop(restaurants, unfiltered) {
      //This month's features:......
      const thisMonthFeatured = [
        //212
        "5f74df542c426345d28fec9d",
        //Bar Centraal
        "5f74df542c426345d28fec03",
        //Bistrot des Alpes
        "6116899566957e10cf83df44",
        //Foer
        "5f74df542c426345d28feca4",
        //Friedhats FUKU
        "5f74df542c426345d28fec58",
        //Golden temple
        "5f74df542c426345d28fec1b",
        //Little plant pantry
        "60e46b0dbc43f02b67fc85dd",
        //De waaghals
        "5f74df542c426345d28feca3",
      ];

      let sortedFullList;

      if (unfiltered) {
        const featuredRestaurants = restaurants.filter(restaurant =>
          thisMonthFeatured.includes(restaurant.id)
        );

        //add featured attribute to featured restaurants
        featuredRestaurants.forEach(restaurant => (restaurant.featured = true));

        const remainingRestaurants = restaurants.filter(
          restaurant => !thisMonthFeatured.includes(restaurant.id)
        );

        sortedFullList = [...featuredRestaurants, ...remainingRestaurants];
      } else {
        res.data.data.forEach(
          restaurant =>
            thisMonthFeatured.includes(restaurant.id) &&
            (restaurant.featured = true)
        );

        sortedFullList = res.data.data;
      }

      return sortedFullList;
    }

    if (
      !consciousFilter.length &&
      !lifestyleFilter.length &&
      !vibeFilter.length &&
      !mealFilter.length &&
      !diningFilter.length &&
      !neighborhoodFilter.length &&
      !priceFilter.length &&
      !cuisineFilter.length
    ) {
      res.data.data = pullFeaturedToTop(res.data.data, true);
    } else {
      res.data.data = pullFeaturedToTop(res.data.data, false);
    }

    //create map features from restaurant list
    dispatch(createFeatures(res.data.data));

    // const restaurantCollection = { res: res.data.data };

    // dispatch({
    //   type: GET_SEARCH_RESULTS,
    //   payload: restaurantCollection,
    // });
  } catch (err) {
    // LogRocket.log(err.message);
  }
};

export const getArticleMap = restaurantIds => async dispatch => {
  setLoading();
  try {
    const res = await axios.get(
      `https://tablesageapi.com/api/restaurants?ids=${restaurantIds}`
    );
    // create map features from restaurant list
    if (res.data.data.length)
      dispatch(createFeatures(res.data.data, "article"));
  } catch (err) {
    // LogRocket.log(err.message);
  }
};

export const createFeatures = (res, kind) => dispatch => {
  setLoading();
  if (!res.length) {
    kind && kind === "article"
      ? dispatch({
          type: GET_ARTICLE_MAP,
          payload: res,
        })
      : dispatch({
          type: GET_SEARCH_RESULTS_MAP,
          payload: res,
        });

    return;
  }

  // const features = [];
  for (let restaurant of res) {
    restaurant.features = [];
    restaurant.mapPoints = [];
    for (let location of restaurant.locations) {
      restaurant.features.push({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: location.coordinates,
        },
        properties: {
          id: restaurant.id,
          name: restaurant.name,
          street: location.street,
          postalCodeCity: location.postalCodeCity,
          slug: restaurant.slug,
          tags: {
            cuisine: restaurant.cuisine,
            meals: restaurant.meals,
            sustainability: restaurant.sustainable,
          },
        },
      });
    }
    for (let feature of restaurant.features) {
      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
      })
        .setHTML(
          `<div id="popup" class="popup-container"><h3 className="popup">${feature.properties.name}</h3><p className="popup">${feature.properties.street}</p><p>${feature.properties.postalCodeCity}</p></div>`
        )
        .setMaxWidth("200px");

      const el = document.createElement("div");
      el.id = `${feature.geometry.coordinates[0]}-${feature.geometry.coordinates[1]}`;
      el.classList.add(feature.properties.id);
      el.classList.add(feature.properties.slug);
      el.classList.add("marker");
      el.style.backgroundImage = "url(https://i.imgur.com/ulHpWO6.png)";
      el.style.width = "24px";
      el.style.height = "30px";
      el.style.backgroundSize = "contain";
      el.style.backgroundRepeat = "no-repeat";

      restaurant.mapPoints.push({
        el,
        popup,
        coordinates: feature.geometry.coordinates,
        id: feature.properties.id,
      });
    }
  }
  // const mapPointArray = Array.from(mapPoints);

  // popup._content.onclick = function (setMapView) {
  //   if (window.outerWidth <= 1075) {
  //     setMapView(false);
  //     //scroll to top of section
  //     const targetElement = document.querySelector("#target-map");
  //     if (targetElement) targetElement.scrollIntoView();
  //   }
  //   setFilters({ restaurantSearchFilter: feature.properties.id }, history);
  // };

  kind && kind === "article"
    ? dispatch({
        type: GET_ARTICLE_MAP,
        payload: res,
      })
    : dispatch({
        type: GET_SEARCH_RESULTS_MAP,
        payload: res,
      });
};

//clear out all filters
export const clearFilters = () => dispatch => {
  dispatch({
    type: CLEAR_ALL_FILTERS,
  });
};

//clear restaurant list
export const clearRestaurantList = () => dispatch => {
  dispatch({
    type: CLEAR_RESTAURANT_LIST,
  });
};

//set filter state with user preferences, and reload restaurant results
export const setFilters = (filters, history, restaurants) => async dispatch => {
  if (filters.hasOwnProperty("cuisineFilter")) {
    dispatch({
      type: SET_CUISINE_FILTER,
      payload: filters.cuisineFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          [],
          [],
          filters.cuisineFilter,
          [],
          [],
          null,
          history,
          [],
          [],
          []
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          restaurants.consciousFilter,
          restaurants.lifestyleFilter,
          filters.cuisineFilter,
          restaurants.diningFilter,
          restaurants.mealFilter,
          null,
          history,
          restaurants.priceFilter,
          restaurants.vibeFilter,
          restaurants.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("priceFilter")) {
    dispatch({
      type: SET_PRICE_FILTER,
      payload: filters.priceFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          [],
          [],
          [],
          [],
          [],
          null,
          history,
          filters.priceFilter,
          [],
          []
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          restaurants.consciousFilter,
          restaurants.lifestyleFilter,
          restaurants.cuisineFilter,
          restaurants.diningFilter,
          restaurants.mealFilter,
          null,
          history,
          filters.priceFilter,
          restaurants.vibeFilter,
          restaurants.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("vibeFilter")) {
    dispatch({
      type: SET_VIBE_FILTER,
      payload: filters.vibeFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          [],
          [],
          [],
          [],
          [],
          null,
          history,
          [],
          filters.vibeFilter,
          []
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          restaurants.consciousFilter,
          restaurants.lifestyleFilter,
          restaurants.cuisineFilter,
          restaurants.diningFilter,
          restaurants.mealFilter,
          null,
          history,
          restaurants.priceFilter,
          filters.vibeFilter,
          restaurants.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("neighborhoodFilter")) {
    dispatch({
      type: SET_NEIGHBORHOOD_FILTER,
      payload: filters.neighborhoodFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          [],
          [],
          [],
          [],
          [],
          null,
          history,
          [],
          [],
          filters.neighborhoodFilter
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          restaurants.consciousFilter,
          restaurants.lifestyleFilter,
          restaurants.cuisineFilter,
          restaurants.diningFilter,
          restaurants.mealFilter,
          null,
          history,
          restaurants.priceFilter,
          restaurants.vibeFilter,
          filters.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("mealFilter")) {
    dispatch({
      type: SET_MEAL_FILTER,
      payload: filters.mealFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          [],
          [],
          [],
          [],
          filters.mealFilter,
          null,
          history,
          [],
          [],
          []
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          restaurants.consciousFilter,
          restaurants.lifestyleFilter,
          restaurants.cuisineFilter,
          restaurants.diningFilter,
          filters.mealFilter,
          null,
          history,
          restaurants.priceFilter,
          restaurants.vibeFilter,
          restaurants.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("lifestyleFilter")) {
    dispatch({
      type: SET_LIFESTYLE_FILTER,
      payload: filters.lifestyleFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          [],
          filters.lifestyleFilter,
          [],
          [],
          [],
          null,
          history,
          [],
          [],
          []
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          restaurants.consciousFilter,
          filters.lifestyleFilter,
          restaurants.cuisineFilter,
          restaurants.diningFilter,
          restaurants.mealFilter,
          null,
          history,
          restaurants.priceFilter,
          restaurants.vibeFilter,
          restaurants.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("diningFilter")) {
    dispatch({
      type: SET_DINING_FILTER,
      payload: filters.diningFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          [],
          [],
          [],
          filters.diningFilter,
          [],
          null,
          history,
          [],
          [],
          []
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          restaurants.consciousFilter,
          restaurants.lifestyleFilter,
          restaurants.cuisineFilter,
          filters.diningFilter,
          restaurants.mealFilter,
          null,
          history,
          restaurants.priceFilter,
          restaurants.vibeFilter,
          restaurants.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("consciousFilter")) {
    dispatch({
      type: SET_CONSCIOUS_FILTER,
      payload: filters.consciousFilter,
    });

    if (!restaurants) {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          filters.consciousFilter,
          [],
          [],
          [],
          [],
          null,
          history,
          [],
          [],
          []
        )
      );
    } else {
      dispatch(
        getSearchResultsMap(
          "5f69d9b4b28c5e1f8f369c42",
          filters.consciousFilter,
          restaurants.lifestyleFilter,
          restaurants.cuisineFilter,
          restaurants.diningFilter,
          restaurants.mealFilter,
          null,
          history,
          restaurants.priceFilter,
          restaurants.vibeFilter,
          restaurants.neighborhoodFilter
        )
      );
    }
  }
  if (filters.hasOwnProperty("restaurantSearchFilter")) {
    dispatch({
      type: SET_RESTAURANT_SEARCH_FILTER,
      payload: filters.restaurantSearchFilter,
    });

    dispatch(
      getSearchResultsMap(
        "5f69d9b4b28c5e1f8f369c42",
        [],
        [],
        [],
        [],
        [],
        filters.restaurantSearchFilter,
        history,
        [],
        [],
        []
      )
    );
  }
};

//set loading to true
const setLoading = () => {
  return {
    type: SET_LOADING,
  };
};
